import React from "react";
import PropTypes from "prop-types";
import { CURRENT_MEETING } from "../../constants.js";
import {
  DEFAULT_USER_TYPE_VALUE,
  USER_TYPE_VALUES_BY_CODE,
} from "../../constants/adminConstants";
import Button from "components/CustomButtons/Button.js";
import Edit from "@material-ui/icons/Edit";
import Info from "@material-ui/icons/Info";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

export const EditButton = ({ onClick }) => (
  <div className="actions-right">
    <Button
      justIcon
      round
      simple
      onClick={onClick}
      color="warning"
      className="edit"
    >
      <Edit />
    </Button>
  </div>
);

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export const processRegistrationData = (
  registrations,
  statNumeric,
  openRegistrationModal,
) => {
  const statTypeText = statNumeric === "2" ? CURRENT_MEETING : "";

  const selectedRegistrations = registrations.filter(
    (reg) => reg.conference_name === statTypeText,
  );

  return {
    total: selectedRegistrations.length,
    inPerson: selectedRegistrations.filter(
      (reg) => reg.registration_type === "in_person",
    ).length,
    virtual: selectedRegistrations.filter(
      (reg) => reg.registration_type === "virtual",
    ).length,
    data: selectedRegistrations.map((prop) => ({
      id: prop.id,
      name: prop.name,
      institution: prop.institution,
      role: prop.role,
      registration_type: prop.registration_type,
      need_time: prop.need_time ? "Yes" : "No",
      actions: (
        <div className="actions-right">
          <Button
            justIcon
            round
            simple
            onClick={() => openRegistrationModal(prop)}
            color="info"
            className="info"
          >
            <Info />
          </Button>
        </div>
      ),
    })),
  };
};

export const processUserData = (
  users,
  openModal,
  updateFormData,
  confirmDeleteUser,
) => {
  return users.map((prop) => ({
    id: prop.id,
    name: prop.name,
    email: prop.email,
    type: prop.type,
    institution: prop.institution,
    actions: (
      <div className="actions-right">
        <Button
          justIcon
          round
          simple
          onClick={() => {
            updateFormData("id", prop.id);
            updateFormData("name", prop.name);
            updateFormData("email", prop.email);
            updateFormData("institution", prop.institution);
            updateFormData("about", prop.about);
            updateFormData(
              "typeNumeric",
              USER_TYPE_VALUES_BY_CODE[prop.type] || DEFAULT_USER_TYPE_VALUE,
            );
            openModal("updateUser");
          }}
          color="warning"
          className="edit"
        >
          <Edit />
        </Button>
        <Button
          justIcon
          round
          simple
          onClick={() => confirmDeleteUser(prop.id, prop.name)}
          color="danger"
          className="delete"
        >
          <Close />
        </Button>
      </div>
    ),
  }));
};

export const processDataRequestsData = (
  dataRequests,
  updateFormData,
  openModal,
) => {
  return dataRequests.map((prop) => ({
    id: prop.id,
    name: prop.name,
    actions: (
      <div className="actions-right">
        <Button
          justIcon
          round
          simple
          onClick={() => {
            updateFormData("id", prop.id);
            updateFormData("name", prop.name);
            updateFormData("email", prop.email);
            updateFormData("institution", prop.institution);
            updateFormData("type", prop.type);
            updateFormData("description", prop.description);
            openModal("dataRequestsInfo");
          }}
          color="info"
          className="info"
        >
          <Info />
        </Button>
      </div>
    ),
  }));
};

export const processTentativeData = (
  tentatives,
  confirmApproveUser,
  confirmDenyUser,
) => {
  return tentatives.map((prop) => ({
    id: prop.id,
    name: prop.name,
    institution: prop.institution,
    message: prop.message,
    email: prop.email,
    actions: (
      <div className="actions-right">
        <Button
          justIcon
          round
          simple
          onClick={() =>
            confirmApproveUser(
              prop.id,
              prop.email,
              prop.name,
              "member",
              prop.institution,
              "",
            )
          }
          color="success"
          className="approve"
        >
          <Check />
        </Button>
        <Button
          justIcon
          round
          simple
          onClick={() => confirmDenyUser(prop.id, prop.name)}
          color="danger"
          className="deny"
        >
          <Close />
        </Button>
      </div>
    ),
  }));
};

